import { BankAccount } from '@/types';
import { logger } from '@/utils/logger';

export interface AccountsState {
  accounts: BankAccount[];
  isLoading: boolean;
}

export type AccountsAction =
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_ACCOUNTS'; payload: BankAccount[] }
  | { type: 'ADD_ACCOUNT'; payload: BankAccount }
  | { type: 'UPDATE_ACCOUNT'; payload: { id: string; updates: Partial<BankAccount> } }
  | { type: 'DELETE_ACCOUNT'; payload: string }
  | { type: 'CLEAR_ACCOUNTS' };

export const initialState: AccountsState = {
  accounts: [],
  isLoading: false,
};

export function accountsReducer(
  state: AccountsState,
  action: AccountsAction
): AccountsState {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };

    case 'SET_ACCOUNTS':
      return { 
        ...state, 
        accounts: action.payload,
        isLoading: false
      };

    case 'ADD_ACCOUNT':
      logger.debug('Adding account to state', { id: action.payload.id });
      return {
        ...state,
        accounts: [...state.accounts, action.payload],
      };

    case 'UPDATE_ACCOUNT': {
      const updated = state.accounts.map(a =>
        a.id === action.payload.id ? { ...a, ...action.payload.updates } : a
      );
      logger.debug('Updated account in state', { id: action.payload.id });
      return { ...state, accounts: updated };
    }

    case 'DELETE_ACCOUNT': {
      const filtered = state.accounts.filter(a => a.id !== action.payload);
      logger.debug('Deleted account from state', { id: action.payload });
      return { ...state, accounts: filtered };
    }

    case 'CLEAR_ACCOUNTS':
      return { ...state, accounts: [] };

    default:
      return state;
  }
}
